import React from 'react';

import { Heading, Icon, Spacer, Text } from '@zillow/constellation-10';
import { IconCheckmarkCircleFilled } from '@zillow/constellation-icons';

interface IntermediateStepTypes {
  headingLevel?: 3 | 4;
  headingText: string;
  bodyText?: string;
  children: React.ReactNode;
}

export const IntermediateStep = ({
  headingLevel = 3,
  headingText,
  bodyText = '',
  children = null,
}: IntermediateStepTypes) => (
  <Spacer css={{ marginBlockStart: 'sm', marginBlockEnd: 'md' }}>
    <Icon render={<IconCheckmarkCircleFilled />} size="md" css={{ color: 'green500' }} />
    <Spacer css={{ paddingBlockStart: 'md' }}>
      <Heading level={headingLevel}>{headingText}</Heading>
    </Spacer>
    {bodyText && (
      <Spacer css={{ paddingBlockStart: 'md' }}>
        <Text textStyle="body">{bodyText}</Text>
      </Spacer>
    )}
    {children && <Spacer css={{ paddingBlockStart: 'md' }}>{children}</Spacer>}
  </Spacer>
);
